module.exports = __webpack_public_path__ + "static/media/DEGEN-ETH.8b760285.png";